import {object, SchemaOf, string} from 'yup';

import {KonzultaCredentials} from '@dms/api/shared';
import i18n from '@dms/i18n';

export const $AuthCredentials: SchemaOf<KonzultaCredentials> = object({
  username: string().required(i18n.t('general.notifications.errorFieldRequired')),
  password: string().required(i18n.t('general.notifications.errorFieldRequired')),
});
